import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { getPlayersExplore } from '../../../../api/licence';
import PlayersLayoutPage from './playersLayoutPage';
import PlayersExplorePage from './playersExplorePage';
import { setPlayersResponse } from '../../../../redux/reducers/licenceAnalytics';

interface FacilitiesPageProps {
  mode: string;
}

const PlayersPage: React.FC<FacilitiesPageProps> = React.memo(({ mode }) => {
  const dispatch = useDispatch();

  const { data: playersResponse = [] } = useQuery('players', getPlayersExplore);
  useEffect(() => {
    const playersWithoutTraning = playersResponse.filter((player:any) => player?.club?.league?.id != 2011);
    dispatch(setPlayersResponse({ response: playersWithoutTraning }));
  }, [playersResponse]);

  return <>{mode === 'Dashboard' ? <PlayersLayoutPage /> : <PlayersExplorePage />}</>;
});

export default PlayersPage;
